const ProfileWeightEnum = {
    None: "",
    Low: "Low",
    Medium: "Medium",
    High: "High"
}

export default ProfileWeightEnum;
